<template>
  <div class="generic-media-page">
    <div v-if="loading" class="generic-source-state">
      <i class="fas fa-spinner fa-spin" aria-hidden="true"></i>
      Chargement du {{ internalMediaLabel }}…
    </div>
    <div v-else-if="loadError" class="generic-source-state generic-source-state--error">
      <span>{{ loadError }}</span>
      <button type="button" @click="prepareSourceDomain">Réessayer</button>
    </div>
    <ContentsList v-else internal-generic-media />
  </div>
</template>

<script>
import ContentsList from '@/pages/Contents/List.vue'
import {
  MEDIA_INTERNAL_DOMAIN_UUID,
  selectInternalSourceDomain
} from '@/services/internalGenericContents.service'
import { INTERNAL_MEDIA_LABEL } from '@/utils/internalMediaLabel'

export default {
  name: 'app-dashboard-generic-media',
  components: { ContentsList },
  computed: {
    internalMediaLabel () {
      return INTERNAL_MEDIA_LABEL
    }
  },
  data () {
    return {
      loading: true,
      loadError: ''
    }
  },
  created () {
    this.prepareSourceDomain()
  },
  methods: {
    async prepareSourceDomain () {
      this.loading = true
      this.loadError = ''
      try {
        await selectInternalSourceDomain(this.$store, MEDIA_INTERNAL_DOMAIN_UUID)
      } catch (error) {
        this.loadError = 'Impossible de charger le domaine Média interne.'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.generic-media-page {
  height: 100%;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
  width: 100%;
}
.generic-source-state {
  margin: 24px;
  padding: 36px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #fff;
  color: #64748b;
  text-align: center;
}

.generic-source-state--error {
  color: #b91c1c;
}

.generic-source-state button {
  margin-left: 12px;
  color: #2563eb;
  font-weight: 600;
}
</style>
